<div class="image-container use-transition">
  <a (click)="goToSerie()">
    <picture>
      <source media="(min-width: 768px)" [srcset]="serie.image">
      <img [src]="serie.cover" />
    </picture>
  </a>
</div> 